type RelatedPayStationDevice = {
    id: string;
    serial_number: string;
    parking?: {
        name: string;
    };
    identifier: string;
};

export type PayStationHeartBeat = {
    id: string;
    timestamp: number;
    screenshot: string;
    device: RelatedPayStationDevice;
};

export type PayStationLog = {
    id: string;
    level: string;
    message: string;
    data: {
        device?: string;
        eventCode?: string;
        eventDescription?: string;
        identifier?: string;
        code?: string;
        activePayment?: string | null;
        details?: {
            results?: { code: string; reason: string }[];
        };
    };
    resolved: boolean;
    resolved_at: number;
    updated_at: number;
    created_at: number;
    device: RelatedPayStationDevice;
};

export enum PAYSTATION_STATES {
    OPERATION = 'operation',
    WARNING = 'warning',
    ERROR = 'error',
    NO_CONNECTION = 'no-connection',
}

export enum PAYSTATION_TYPE_LOG {
    WARNING = 'warning',
    ERROR = 'error',
    INFO = 'info',
}
export enum CURRENCIES {
    BGN = 'BGN',
    EUR = 'EUR',
}

export enum PAYMENT_METHODS {
    CARD = 'card',
    CASH = 'cash',
    ONLINE = 'online',
}

export enum LANGUAGES {
    BULGARIAN = 'Bulgarian',
    ENGLISH = 'English',
}

export enum LOCALE {
    EN = 'en',
    BG = 'bg',
}

export type PayStationDevice = {
    id: string;
    device_model: string;
    serial_number: string;
    ram: number;
    storage_size: number;
    resolution: string;
    dpi: number;
    android_version: string;
    ip: string;
    local_ip: string;
    time_zone: string;
    settings?: {
        password?: string;
        serverHost?: string;
        serverPort?: string;
        imagesURL?: string;
        imagePrefix?: string;
        paymentMethods?: PAYMENT_METHODS[];
        currencies?: CURRENCIES[];
        fiscalDevicePaper?: boolean;
        reportPaperInLength?: boolean;
        lostTicket?: boolean;
        acceptedCoins: {
            [Property in CURRENCIES]: string;
        };
        acceptedBanknotes: {
            [Property in CURRENCIES]: string;
        };
        coinsToReturn: {
            [Property in CURRENCIES]: string;
        };
        banknotesToReturn: {
            [Property in CURRENCIES]: string;
        };
        languages?: LANGUAGES[];
        homeQRValue?: string;
        parkingName?: string;
        receiptURL?: string;
        supportPhone?: string;
        servicesPassword?: string;
        identifier?: string;
        homePayButtonText?: {
            [Property in LANGUAGES]: string;
        };
        defaultLanguage?: LOCALE;
        webId?: string;
        enableSettingsEnter?: boolean;
        enableSubscriptions?: boolean;
    };
    app_version: string;
    app_build_number: number;
    app_push_update_version: string;
    state: string;
    updated_at: number;
    created_at: number;
    parking?: {
        name: string;
    };
    api_key: string;
    identifier: string;
};
